import { StationsAction } from '@/Components/Pages/IRomaScents/StationActionPage';
import { StationDetailPage } from '@/Components/Pages/IRomaScents/StationDetailPage';
import { StationLog } from '@/Components/Pages/IRomaScents/StationsLogPage';
import { Stations } from '@/Components/Pages/IRomaScents/StationsPage';

import { RoutePage } from '../types';

export const StationsPage: RoutePage = {
    url: 'stations',
    component: <Stations />,
    permissions: {
        entity: 'Stations',
        right: 'read',
    },
    sidebar: {
        name: 'iRomaScents Stations',
    },
    children: [
        {
            url: ':id',
            component: <StationDetailPage />,
            children: [
                {
                    url: 'edit',
                    component: <StationsAction />,
                    permissions: {
                        entity: 'Stations',
                        right: 'update',
                    },
                },
                {
                    url: 'logs/:log_id',
                    component: <StationLog />,
                },
            ],
        },
    ],
};
